// Base URL configuration
let baseUrl;
let oauthUrl;
let key;
let posthogKey;
const devKey =
  "pk_test_51QDV8d3ZherjpZePy3GIbI1zOBLrtrQburFAiKZ3WBjU6wNujwbgjCq8u3in4ONRkyeDQgliFfZwNNu1FGkZb4O800IlMG5azJ";
const prodKey =
  "pk_live_51PrfVqKnijChdbV7Ajx0dqUNpbFpkxmK7n56momlrwDMbzf9oBQffqVgJQJr2Rrt3bKf29ysFkO380LRCgc9vRUJ00jpU5kyS6";
const postHogProdKey = "phc_GOJrt0SMSoxbhiaC2hX1SMEZOPg9MQ5sv8TeStF1JKu";
const postHogDevKey = "phc_dOGXzxSgvPcmR6feFlpjildQxhvOnSzZU2Boh0z9gSz";
if (window && window.location.href.includes("192")) {
  baseUrl = "http://192.168.1.97:8090";
  oauthUrl = baseUrl;
  key = devKey;
  posthogKey = postHogDevKey;
} else if (window && window.location.href.includes("localhost")) {
  baseUrl = "http://localhost:8090";
  oauthUrl = baseUrl;
  key = devKey;
  posthogKey = postHogDevKey;
} else if (window && window.location.href.includes("eu.ngrok")) {
  baseUrl = "https://parrot-backend-4gd2x.eu.ngrok.io";
  oauthUrl = baseUrl;
  key = devKey;
  posthogKey = postHogDevKey;
} else if (window && window.location.href.includes("ngrok")) {
  baseUrl = "https://parrot-backend-4gd2x.ngrok.io";
  oauthUrl = baseUrl;
  key = devKey;
  posthogKey = postHogDevKey;
} else {
  baseUrl = "/papi/";
  oauthUrl = window.location.origin + "/papi";
  key = prodKey;
  posthogKey = postHogProdKey;
}
// NOT dev since that once release is now prod.
// we will add a new staging env in the future.
if (window && window.location.href.includes("dev.fluentwithparrot.com")) {
  key = prodKey;
  posthogKey = postHogProdKey;
}
if (window && window.location.href.includes("staging.fluentwithparrot.com")) {
  key = devKey;
  posthogKey = postHogDevKey;
}

export const BAD_AUTH_REDIRECT_URL = "/app/login";

export const API_BASE_URL = baseUrl;
export const OAUTH_REDIRECT_URL = oauthUrl;
export const STRIPE_PUBLISHABLE_KEY = key;
export const POSTHOG_KEY = posthogKey;
